import { useQueryClient } from '@tanstack/react-query'

import { type ApplicationCredential } from 'src/types/application'

import api from 'src/constants/api'

import useAccount from 'src/hooks/utils/useAccount'
import useMutation from 'src/hooks/utils/useMutation'

interface CreateApplicationSecretPayload {
  displayName: string
  endDateTime: string
}

const useCreateApplicationSecretMutation = (appId: string) => {
  const account = useAccount()
  const queryClient = useQueryClient()

  return useMutation(
    async (payload: CreateApplicationSecretPayload) => {
      const response = await api.post(`graph/account/${account.id}/application/${appId}/secrets`, payload)
      return response.data as ApplicationCredential
    },
    {
      onSuccess: (newSecret) => {
        // Optimistically update the applications query cache to include the new secret with secretText
        queryClient.setQueryData(['applications', account.id], (oldData: any) => {
          if (!oldData) return oldData

          return oldData.map((app: any) => {
            if (app.appId === appId) {
              return {
                ...app,
                passwordCredentials: [...(app.passwordCredentials || []), newSecret]
              }
            }
            return app
          })
        })
      },
      successMessage: 'Secret created successfully.',
      errorMessage: 'We were unable to create the secret. If the problem persists, please contact support.'
    }
  )
}

export default useCreateApplicationSecretMutation
